<template>
  <svg
    :x="x"
    :y="y"
    width="200"
    height="180"
    viewBox="0 0 148 120"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    class="svg-bush"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M37.74 116.287v.8l.6.5.9.9.1.1.7.6.1.1h.6l-3-3zM38.84 113.787l-.8.7 5 4.9H43.64l.4-.4-5.2-5.2zM41.54 112.887l-1.1.3 4.8 4.8.6-.5.2-.1-4.5-4.5zM44.54 112.287l-.7.1-.5.1 4.1 4.1.1-.1.9-.3-3.9-3.9zM47.34 111.487l-1.1.3 3.9 3.9.2-.1.8-.3-3.8-3.8zM49.84 110.387l-.2.2-.6.3h-.1l3.8 3.8 1.1-.4-4-3.9zM51.04 107.987l-.2.4-.2.5 4.8 4.8 1-.3-5.4-5.4zM51.64 104.887v.1l-.2 1.2 8.3 8.3 1.5.8 1 .4.3.1-10.9-10.9zM60.04 109.687l-1.2.2 1.8 1.9 1.1-.4-1.7-1.7zM64.74 114.487l-.1-.1-.7-.2-2-1.4-.7-.4 4 3.9.6.1.8-.1-1.9-1.8zM56.04 107.187l-.1-.4-.1-1.2-3.5-3.5-.4.4-.1.5 4.2 4.2zM63.04 109.187l-1.2.2 1.5 1.5 1.1-.4-1.4-1.3zM46.34 93.887l3.6 2.1-2.6-2.5-1 .3v.1zM68.34 114.387l-1.4.1 1.8 1.7h1.3l-1.7-1.8zM56.24 102.487v-.1l-2-2-.7.6 2.2 2.3.1-.3.4-.5zM54.24 98.187l1.9.7-.6.5 1.8 1.9.7-.7-8.1-8.1-.3.1-.7.3 5.3 5.3zM71.84 114.387h-1.3l1.6 1.7 1.3-.1-1.6-1.6zM63.94 106.487l.9 1.6 1.1.6-1 .1 1.1 1.2 1-.4-3.1-3.1zM75.44 114.387h-1.4l1.5 1.5 1.4-.1-1.5-1.4zM52.64 91.487l-1.1.4 8.8 8.8.4.1.2.5 10.5 10.4 3.2 1.9-22-22.1zM47.04 83.787l2.6 1.2-2.5-2.6-1 .4.9 1zM55.24 90.487l-1 .4 24.8 24.8h1.3l-25.1-25.2zM57.84 89.587l-1 .3 26.9 26.9 2.1.8-28-28zM49.74 81.487l-1 .3 5 5 2.6 1.2-6.6-6.5zM52.34 80.487l-1 .4 36.6 36.6 1.1-.3-36.7-36.7zM54.94 79.487l-1 .4 36.9 36.8 1.1-.3-37-36.9zM57.14 78.087l-.6.7 37.1 37.2 1.2-.3-37.7-37.6zM59.14 76.487l-.8.5 38.2 38.2 1.1-.3-38.5-38.4zM61.34 75.087l-.8.5 39.1 39.2 1.799.3-40.1-40zM63.54 73.587l-.8.6 41.3 41.4 1.8.3-42.3-42.3zM65.74 72.187l-.8.6 43.6 43.6 1.7.3-44.5-44.5zM67.94 70.787l-.9.6 45.699 45.6 1.5.1-46.3-46.3zM71.04 70.287l-1.7-.3 47.299 47.3 1.5.1-47.1-47.1zM75.34 70.987l-1.7-.3 46.9 46.9 1.6.2-46.8-46.8zM79.74 71.787l-1.7-.3 45.899 45.9.8-.6-45-45zM83.14 71.587l-1 .4 43.9 43.9.8-.6-43.7-43.7zM85.94 70.687l-1.1.4 43.199 43.2.8-.6-42.9-43zM88.74 69.987l-.3-.1-.9.3 42.599 42.6.8-.6-42.2-42.2zM92.84 70.487l-.5-.3-1 .2 40.799 40.8.8-.6-40.1-40.1zM98.84 72.887l-2-.6 37.399 37.4.8-.6-36.2-36.2zM103.139 73.987l-.4-.1-1.4-.4 34.7 34.8.8-.6-33.7-33.7zM107.14 74.287l-.9.2-.5-.1 31.899 31.9-.299-1.8-30.2-30.2zM110.239 73.787l-1.2.2 28.9 29 1.1-.3-28.8-28.9zM113.34 73.287l-1.2.2 28.2 28.2.8-.6-27.8-27.8zM120.34 76.787l-1.6-.3 23.6 23.7.799-.7-22.799-22.7zM115.24 72.987l2.9 2.9-2.201-3-.699.1zM138.94 91.687l-1.8-1.1-.6-1.3-11.9-11.9-1.7-.2 21.4 21.4.3-.2.7-.3-6.4-6.4zM127.14 77.787l7.1 7-1.4-2.8-4-4-1.7-.2zM146.84 97.387l.7-.4-2.9-1.7 2.2 2.1z"
        fill="#000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.04 112.987h.1v.3l-.1-.1v-.2z"
        fill="url(#paint0_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.74 116.787l1.1.3c.4-.1.8-.4 1.4-.9.5-.3.8-.6 1-1.2.4-.9-.1-1-.1-1.8 0-.9-2-1.6-3-2-1-.4-1.5-.3-2.2-.3-.5 1 .2.1.4.3.1.2 1.4 5.6 1.4 5.6z"
        fill="#7D9723"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.04 93.287l4.1-7.8.5-.1-3.7 8.2-1.4.1.5-.4z"
        fill="url(#paint1_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.74 93.787l3.7-7.7-.3-1.4-.8.8-3.9 7.8 2 .8-.7-.3z"
        fill="url(#paint2_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.74 93.787l3.4-8.3h.6l-1 4.4-1.1 4.1-1.2.1-.7-.3z"
        fill="url(#paint3_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.34 93.787l2.4-8.3h.3l-2.1 8.3-.2.5-.4-.5z"
        fill="#A9834A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.04 92.687l-2.3-1.1-1.2-.9-4.1-3.7-.6-.9-.6-1.2.8 3.4 5.3 5.1 1.2.9 2 .2-.5-1.8z"
        fill="url(#paint4_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.24 94.187l-3.2-.3-3.5-.2-2.1-.4-2.4-.6-.6 1 .4 1.1 9.3.1 1.3.4 1.4-.8-.5-.1-.1-.2z"
        fill="#856F35"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.34 94.487l.2-.3.4-.1.4-.2 8.9-9.3h.7l.1 1-9.6 9.6-1.5.7-.8-.7 1.2-.7z"
        fill="url(#paint5_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.44 93.687l1.8.4 3.5.4 4.2.3h1.4l.9-.3-.2 1-1.1.7-9.9.4-2.4-1.1 1.8-1.8z"
        fill="#917136"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.74 92.887l1.6.9-1 1.7-1.8-.3.2-.9 1-1.4z"
        fill="#967239"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.74 94.187l.8-.1.2-1.3-5.2-4.9-.7-1-1.8-6.9-2 .7 1.6 7.5 2.6 3.4 4.5 2.6z"
        fill="url(#paint6_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.44 95.387l2.6.4 9 .1 1.2-.4 1.2-.8 9.5-10.1 1.9-.8-.8 1.4-7.2 8.2-3.6 3.4-1.8.6-8.4.2-3.3.2-2.8-1.9.4-.3 2.1-.2z"
        fill="url(#paint7_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M55.04 96.887l.9-.6 1-.8 9.6-11.4-.1-.2-10.3 11.4-1.1 1.6z"
        fill="#C1965D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.54 97.187l2.3-.1h4.2l4.7-.2.9.4-1.2.1-2.9.1-2.7.1s-3.6 1.4-3.5 1.4c.1 0-1.9-1.1-1.9-1.1l.1-.7z"
        fill="url(#paint8_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.44 80.787l1.4 7.7 2.9 3.5 3.7 4.4.5-.4 2.5-.5-1.7-1.2-5-4.9-.6-1.1-.6-1.8-.7-3.6-.7-3.3-1.7 1.2z"
        fill="url(#paint9_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.14 89.687l-.5-1-.4-1.4-1.3-6.6-1 .2.8 5.1.2 1.2.4 1.2.8 1.1 1 .2z"
        fill="url(#paint10_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.54 97.187l-3.6-1.3s2 4.2 2.2 4.2h.7l.7-2.9z"
        fill="#A87D40"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.04 98.687l.5 1.3v.8l-.2.6-1.3 3.9-.5.9-.8 1.4-1 2.6-.1.9.4 2 .1.1.3-1.1 3.7-7.6 1.1-3.7-2.2-2.1z"
        fill="#A9814C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.34 111.587l.4-1.4 2.2-4.6.8-2.6.3-1.7v-.3l-.2-.7-.3-1-1.6-3-1.7-2.1-2-2.4-2-2.3.9.1 4.3 4.7 1.5 1.5 2 2.4.4 1.6.6 2.3-.1 7.7-2.2 3.2-3.2.6-.3-.4v-.2l.2-1.4z"
        fill="url(#paint11_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.54 98.887l.6-.2-.2-1h-.9l-.5.2.4.6.6.4z"
        fill="url(#paint12_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.54 98.887l-1-1.1-.5.1.2 1h1.3z"
        fill="#7E5823"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.64 98.287l.2-.2.3-.1.4.6.5.3h.6l-.4 2s-1.1.5-1.2.5l-.7-1.9.3-1.2z"
        fill="#9A753E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.44 105.187l.2-2.1v-.9l-.3-1.2v-1.1s.8-1 .8-1.1c0-.1.5-1.6.5-1.6l2 1-.2 4 .2 4.3v1.4s-1.3-.2-1.4-.2c-.1-.1-1.8-2.5-1.8-2.5z"
        fill="url(#paint13_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.04 114.887l-.5-2.7-.3-1.1-.1-1 .1-1.4.8-3.2.4-1.4 1.4-6.4-2.8 4.8-.9 8.7.9 4.7 1-1z"
        fill="#B98F59"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.74 115.187v-.2l-.1-1.4-.4-1.5-.1-1.8.5-2.8.6-2.3v-1.9l1-3.3.5-1.4.3-.8-.9.1-.5 1-.9 1.5-.8-1.1-.3-1-1.2 1.2.1 1 .6 1.5-.2 2.8.2 2.4-2.1 4.5.5 3.1.6 2.4.2.1 2.4-2.1z"
        fill="url(#paint14_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.64 115.887l-.8-2.1 1.5-1.7 1.5-4.5.6-2.4 2.7 1.9-1.2 4.6v1.8l.2 2.9-1.4.5-2.7-.5-.4-.5z"
        fill="url(#paint15_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.14 116.587l-1.1-2.3.4-2.1-.9-2.9-1.2 1.4-.5 1.2-.6 1.4 3 3.1.9.2z"
        fill="url(#paint16_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.24 117.187l-.1-.8-1.3.1-2.4-4.4-.4 2.1v2l.1.1 4.1.9z"
        fill="url(#paint17_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M42.24 117.187l-.1-.8-1.3.1.2.4 1.2.3z"
        fill="url(#paint18_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.74 96.887l1.2-.5 1.1-.8 10.6-11.9h.8l-10.2 12.3-1.2.9-1.4.4-.9-.4z"
        fill="url(#paint19_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.44 94.787l.9-.6.7-.2-.6.5-1 .3z"
        fill="#8A743A"
      />
      <path
        d="M31.14 79.587l.1.7.8-.3 1.3 5.3.4.9.6.9 4.1 3.7 1.2.9 2.3 1.1 2 .5 4.1-7.8h.3l.7-.7.2.8h.8l-2.1 8.3 2.2.1 3.2.3.7-.2.4-.2 8.9-9.3h.7l1.8-.7h.8l.1.2-9.6 11.4-1 .8-1.1.6-1.4.4-.4-.2h-.1l.4.2-1.2.1-2.9.1-2.7.1-1.4 6.4-.4 1.4-.8 3 .1.5-.1 1.2.1 1 .3 1.1.5 2.7-.9.9-1.7 1.5-.2-.1-4.1-.9-.1-.1-2.5-2.7-.3-.4v-.2l-.4-1.8.1-.9 1-2.6.8-1.4.5-.9 1.3-3.9.2-.6v-.8l-.5-1.3-1.2-2.3-1.8-2.2-2-2.4-2-2.3-.8-1.1-.4-1.2-.2-1.2-.9-5.1.5-.1 1.7-1.2zm0-2c-.4 0-.8.1-1.1.3l-1.4 1h-.1c-1 .2-1.7 1.2-1.5 2.3l.8 5.1.2 1.2c0 .1 0 .2.1.3l.4 1.2c.1.2.2.4.3.5l.8 1.1c0 .1.1.1.1.2l2 2.3 2 2.3 1.4 2.1 1.1 2.1.3.7v.1l-.1.4-1.2 3.8-.4.8-.8 1.4c0 .1-.1.2-.1.3l-1 2.6c-.1.1-.1.3-.1.4l-.1.9v.7l.3 1.7v.5c.1.3.2.6.4.8l.3.4.3.3 2.3 2.4.1.1.1.1c.3.3.6.5 1 .5l4.1.9c.2.1.4.1.6.1.5 0 1-.2 1.3-.5l1.5-1.3c.1 0 .1-.1.2-.1l.9-.9c.5-.5.7-1.1.6-1.8l-.5-2.7v-.2l-.2-1-.1-.7.1-.9v-.2l.7-2.9.4-1.4v-.1l1-4.9h1.2l2.9-.1h.2l1.2-.1c.2 0 .5-.1.7-.2l1-.3c.2-.1.5-.2.7-.3l.9-.6s.1 0 .1-.1l1-.8.3-.3 9.6-11.4c.5-.6.6-1.3.3-2l-.1-.2c-.3-.7-1-1.2-1.7-1.3h-.9c-.3 0-.5 0-.8.1l-1.4.6h-.1c-.5 0-1.1.2-1.4.6l-8.7 9.1-2.6-.2 1.5-6c.2-.6 0-1.2-.4-1.7-.2-.3-.5-.5-.8-.6-.3-.4-.7-.7-1.2-.9-.2 0-.4-.1-.5-.1-.5 0-1.1.2-1.5.6l-.3.3c-.4.2-.8.5-1 .9l-3.3 6-.3-.1-2-.9-.9-.7-3.8-3.5-.4-.5-.3-.5-1.3-5.1c-.1-.5-.5-1-1-1.3-.2-.1-.5-.2-.7-.2-.1-.1-.3-.2-.5-.3-.2-.1-.5-.2-.7-.2z"
        fill="#231F20"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M76.14 13.487l-19.1-10.6 1 15.5 15-2.7 3.1-2.2z"
        fill="#BADF56"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.94 14.287l12.2-.8v6.9l-5.8 6.2-6.4-12.3z"
        fill="url(#paint20_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.34 20.887l3.8-7.4 15.1.5-9.4 18.3-9.6-7.1.1-4.3z"
        fill="#C4E658"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.94 14.287l8.4 6.7 8.2 6.8-4.6.9s-10.8-11-10.8-10.8l-1.2-3.6z"
        fill="#C4E65E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.54 27.587l10.7-13.6-.4 3.7 1.3 9.2-.9 3-10.7-2.3z"
        fill="url(#paint21_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.44 20.887l10.1 6.7 1.7 7.8-.9.7s-4.6-1.5-5-1.8c-.3-.4-5.9-13.4-5.9-13.4z"
        fill="#A8D34D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.74 6.887l-6 10.7 11-1.7-5-9z"
        fill="#CDEC66"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.64 17.487l9.6-5.5-1.5-5.1 6.2 2.6 11.1-6.6 7 11.3-8.1 8.1s-3 4.7-3.8 4.4c-.8-.3-20.5-9.2-20.5-9.2z"
        fill="#C0E357"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.24 22.487l14.7-8.2 6.4 6.7-7.6 3.3-13.5-1.8z"
        fill="#CFEC63"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.44 20.887l-21.2 1.6-.7 5.4 6.3 5.5 15.6-12.5z"
        fill="#CAE95F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.44 20.887l-15.7 7.6-1.3 8.8 8.3 6.5s8.2-11 8.5-11.4c.2-.6.2-11.5.2-11.5z"
        fill="#C4E657"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.54 39.987l8.9-19.1 10.6 14.7-9.8 3.6-9.7.8z"
        fill="#B0D74C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.64 17.487l17.6 5 5.5 6s-9.5 1.3-10.6 1.2c-1.1-.1-11.9-6.5-11.9-6.5l-.6-5.7z"
        fill="#C5E65E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.64 20.287l7.4-.5-1.7 1.3-4 .4-1.7-1.2z"
        fill="#DDF572"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.74 21.987l.9-1.7 5.7 1.1s-4 1.6-4.4 1.4c-.3-.3-2.2-.8-2.2-.8z"
        fill="#C3E55B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.84 22.887l-4.2-5.4-15 5.2 18 3 1.2-2.8z"
        fill="#CAE862"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.84 22.887l18.9 5.6-1.1 6.1-2.4 3.6-15.8-9.3.4-6z"
        fill="#C3E359"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.64 22.687l19.2.2 14.4 11.8s-9.6 1.4-10 1.3c-.4 0-16.6-3.3-16.6-3 .1.3-7-10.3-7-10.3z"
        fill="#C5E658"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.24 34.787l-21.7-1.3 7.2 9.8 6.6.9 7.9-9.4z"
        fill="#A4D63F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.94 42.287l10.3-7.5-3.5 15.7-1.9 2.1-4.9-10.3z"
        fill="#C7E85D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.64 49.887l4.6-15.1 4.5-6.3 6.8 11.5-5.9 8.6-10 1.3z"
        fill="#B9DD52"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M80.54 27.587l9.4.3 6.5 5.1s-10.8-1.2-10.9-1.4c0-.1-5-4-5-4z"
        fill="#C1E35D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.04 35.587l-.5-8 15.9 5.4s-12.8 3.2-13 3.2c-.1 0-2.4-.6-2.4-.6z"
        fill="#BEE159"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.54 39.987l19.5-4.5-6.8 11.4s-5.4.1-5.9-.2c-.5-.3-6.8-6.7-6.8-6.7z"
        fill="url(#paint22_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.54 43.987l9.5-8.4 5.7 7.2-5.1 3.2-10.1-2z"
        fill="#AEDA47"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.34 43.887l13.7-8.2-9.5 8.4 10.1 2-14.3-2.2z"
        fill="url(#paint23_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.54 43.987l11.2.5 1.7 8.5s-12.7 2.1-12.8 2.3c-.1.1-3.6.1-3.8-.1-.3-.3 0-10.2 0-10.2l3.7-1z"
        fill="#C3E558"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M67.64 44.887l3.9-.9-4.2-.1.3 1z"
        fill="#67A622"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.64 49.887l16-9.9-1.8 17.9-17.9 4.7 3.7-12.7z"
        fill="url(#paint24_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.44 57.687l11.1-17.7 9.6 14.9-10.1 3-10.6-.2z"
        fill="#C3E556"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.64 49.887l4.9 7.8-9.4-.9-10.9-3.6 1.1-3.1 14.3-.2z"
        fill="url(#paint25_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.94 42.287l5.6 7.6-14.3 3-1-2.5 9.7-8.1z"
        fill="#CBEB5F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.74 47.687l13.2-5.4-11.4-8.8-3.1 4.2 1.3 10z"
        fill="url(#paint26_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.94 58.387l12.3-5.5 8.7-10.5-12.1 2.8-8.9 13.2z"
        fill="#C9E85E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14 36.287l11.4-6.1 6.1 5.9-17.5.2z"
        fill="#D3EF69"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.04 55.687l4.8-10.6-14.1-12-10.6 3.2 4.9 12.1 15 7.3z"
        fill="#C5E758"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.04 53.587l-.9-17.3 5.2 10.2-1.3 3.8-3 3.3z"
        fill="#C1E35D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.74 33.087l2.9-10.4 11.9 10.8-14.8-.4z"
        fill="#B2DB4F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.54 33.487l-.7 11.6-14.1-12 14.8.4z"
        fill="#BDE152"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.04 55.687l-14.7-9.2-4.3 7.2 13.2 9 6.2-6.3-.4-.7z"
        fill="url(#paint27_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.04 55.687l8.2-2.8 19.2 4.8-13.5 3.5-13.9-5.5z"
        fill="url(#paint28_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.84 61.787l6.1-6.1 11.1 2.6-12.9 4.5-4.3-1z"
        fill="url(#paint29_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.14 54.987l11.9-4.1-6.8 11.5-7.3-3.5 2.2-3.9z"
        fill="#98C63E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.44 57.687l20.6-2.7 4.4 5.2-19.9.6-5.1-3.1z"
        fill="#93C33A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.44 57.687l-.7 13.3 25.7-10.9-25-2.4z"
        fill="url(#paint30_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.84 61.787l14.5 11.2 19-4.9.1-10.4-17.2 1.3-7.2.9-9.2 1.9z"
        fill="#BAE051"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.94 56.187l-.9-2.6 12.8 8.2 2.2 3.4s-3.2-.7-3.3-.9c-.2-.1-10.8-8.1-10.8-8.1z"
        fill="url(#paint31_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.94 56.187l-2.7 12.9 15.3-2.4-1.1-2.2-11.5-8.3z"
        fill="url(#paint32_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.64 63.787l-12.7-7.6 4.7 5.5 6.9 4.4s1.3.7 1.4.6c.1-.1 1.8-1.4 1.8-1.4l-2.1-1.5z"
        fill="url(#paint33_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.34 65.787l-16.1 3.3 18-2-1.9-1.3z"
        fill="url(#paint34_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.04 67.787l-3.2 14 8.2.2-5-14.2z"
        fill="#B9E059"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.74 77.787l5.3-7.9-3-2.2-2.3 10.1z"
        fill="#73AA32"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.74 71.387l-8.7 10.5 10.6-1.9 9-4.1-.5-3.7-10.4-.8z"
        fill="url(#paint35_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.74 44.487l-1.7-8.8 15.4-2.6 3.1 23.6-11-.1-5.8-12.1z"
        fill="url(#paint36_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.74 44.487l.3 6.4-2.4 10.5s1.8 3.7 2 3.5c.1-.2 6.7-9.4 6.7-9.4l-6.6-11z"
        fill="url(#paint37_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.54 61.787l-4.3 3.4s-12.6-.1-12.4.3c.2.4 4.7-3.7 4.7-3.7l5-1.6 7 1.6z"
        fill="url(#paint38_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.24 69.987l11.1-5.8 10.1-7.5-8.7-2.6-8.3 7.7-6.4 3.7s1 4.7.6 4.6c-.3-.2 1.6-.1 1.6-.1z"
        fill="url(#paint39_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.24 75.487l6.6 1.7 18.9-5.5-2.3-4.3-5.2-2.7-18.2 9.1.2 1.7z"
        fill="url(#paint40_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.64 80.087l6.9-6.9 3.2-1.9 6 5 5.4 3.7-1.8 3.7-19.7-3.6z"
        fill="url(#paint41_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.54 73.587l11.2 6.1-1.8-3.2-2-1.5-4.6-2.2-2.8.8z"
        fill="url(#paint42_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.24 69.987l-.4-1.4-2 1.6-.2 1.5-24.7 3.3 3.7 4.7 14.1.5 9.5-10.2z"
        fill="#89BB34"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.64 80.087l20.1-.4 6.6 1.4-1.1 4.8-13.8.1-11.8-5.9z"
        fill="#86BB32"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.74 79.687l20.9-8.1 2.6-1.7-4.8 12.6-13.2 3.4-3.4-3.9-2.1-2.3z"
        fill="url(#paint43_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51.04 74.987l-18.3-3.5 18.1-3.4 24.7-7.8-24.5 14.7z"
        fill="url(#paint44_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M68.14 64.587l14.3-2.8-4.6 6.8-1 1.4-1.2 1.7-3.4-3.3-4.1-3.8z"
        fill="url(#paint45_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.54 61.787l.5-10.9-7.5 9.3 7 1.6z"
        fill="#84B537"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.04 81.987l-7.2-20.2 15.8 9.6-8.6 10.6z"
        fill="#ADD64D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.84 61.787l17.2-3.5 16.4-.6-13.2 4.5-3.6-.5-7.4-1.7-9.4 1.8z"
        fill="url(#paint46_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.54 39.987l5.8 3.8 3.7 11.1-9.5-14.9z"
        fill="url(#paint47_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M61.54 39.987l5.8 3.8.3 1-6.1-4.8z"
        fill="#74B226"
      />
      <path
        d="M57.04 2.887l19.2 10.6 15 .5-.4 3.7 1.3 9.2-.7 2.1 5.1 4 3.1 23.6h-.2.2l-10.1 7.5-11.3 5.9-4.8 12.6-13.2 3.3-13.8.1-11.8-5.9-10.6 1.9-.2-.5.2.5-8.2-.2 3.2-14-.2-.5-16.6 1.8 2.7-12.9-.9-2.6-.9-17.3 11.4-6.1 2.1-7.5 2.1-.7.9-1.7 5-.3 7-2.4 3.1-1.8 5-8.8 6.2 2.6 11.1-6.7zm0-2c-.4 0-.7.1-1 .3l-10.2 6-5.3-2.2c-.3-.1-.5-.1-.8-.1-.7 0-1.4.4-1.7 1l-4.8 8.4-2.5 1.4-6.5 2.2-4.7.3c-.7 0-1.3.4-1.6 1.1l-.5 1-1.4.5c-.6.2-1.1.7-1.3 1.4l-1.9 6.6-10.6 5.7c-.7.4-1.1 1.1-1.1 1.9l.9 17.4c0 .2 0 .4.1.6l.7 2-2.6 12.3c-.1.6.1 1.3.5 1.8.2.2.4.3.6.4.3.1.5.2.8.2h.2l14.1-1.6-2.7 11.8c-.1.6 0 1.2.4 1.7s.9.8 1.5.8l8.2.2h.5l9.9-1.8 11.2 5.6c.3.1.6.2.9.2l13.9-.1c.2 0 .3 0 .5-.1l13.2-3.3c.6-.2 1.2-.6 1.4-1.2l4.6-11.9 10.5-5.4c.1 0 .2-.1.3-.2l10.099-7.5c.1-.1.2-.1.2-.2l.1-.1c.4-.4.6-1 .5-1.6l-3.1-23.6c-.1-.5-.3-1-.7-1.3l-4-3.1.3-.8c.1-.3.1-.6.1-.9l-1.2-9 .4-3.5c.1-.6-.1-1.1-.5-1.5-.4-.4-.9-.7-1.4-.7l-14.6-.5-19-10.4c-.3-.1-.6-.2-.9-.2z"
        fill="#231F20"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="35.172"
        y1="114.926"
        x2="35.235"
        y2="118.532"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E2B577" />
        <stop offset="1" stop-color="#C89C5B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="47.272"
        y1="87.777"
        x2="44.947"
        y2="92.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#967642" />
        <stop offset="1" stop-color="#997943" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="47.121"
        y1="89.892"
        x2="45.958"
        y2="92.505"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8C6D35" />
        <stop offset="1" stop-color="#83652F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="48.324"
        y1="89.165"
        x2="47.278"
        y2="92.204"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#967439" />
        <stop offset="1" stop-color="#8C6A35" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="34.218"
        y1="87.425"
        x2="41.98"
        y2="93.711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#967B43" />
        <stop offset="1" stop-color="#8B7138" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="63.257"
        y1="85.853"
        x2="53.25"
        y2="94.865"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#826E30" />
        <stop offset="1" stop-color="#90743C" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="31.896"
        y1="81.002"
        x2="36.586"
        y2="92.612"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#99793F" />
        <stop offset="1" stop-color="#99753F" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="42.387"
        y1="98.319"
        x2="60.737"
        y2="88.147"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A47C42" />
        <stop offset="1" stop-color="#92723A" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="52.176"
        y1="97.285"
        x2="44.033"
        y2="97.998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AD8548" />
        <stop offset="1" stop-color="#A98142" />
      </linearGradient>
      <linearGradient
        id="paint9_linear"
        x1="37.001"
        y1="94.592"
        x2="29.853"
        y2="80.562"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57E43" />
        <stop offset="1" stop-color="#A37D43" />
      </linearGradient>
      <linearGradient
        id="paint10_linear"
        x1="31.268"
        y1="89.17"
        x2="29.256"
        y2="81.101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AD8548" />
        <stop offset="1" stop-color="#A98247" />
      </linearGradient>
      <linearGradient
        id="paint11_linear"
        x1="34.874"
        y1="101.673"
        x2="30.267"
        y2="109.985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A17C3F" />
        <stop offset="1" stop-color="#A67F4D" />
      </linearGradient>
      <linearGradient
        id="paint12_linear"
        x1="45.777"
        y1="97.948"
        x2="44.967"
        y2="98.559"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#916B35" />
        <stop offset="1" stop-color="#7C5825" />
      </linearGradient>
      <linearGradient
        id="paint13_linear"
        x1="42.213"
        y1="104.254"
        x2="43.303"
        y2="119.847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57C41" />
        <stop offset="1" stop-color="#A67F46" />
      </linearGradient>
      <linearGradient
        id="paint14_linear"
        x1="44.742"
        y1="110.262"
        x2="48.089"
        y2="134.082"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AB844B" />
        <stop offset="1" stop-color="#99743E" />
      </linearGradient>
      <linearGradient
        id="paint15_linear"
        x1="39.598"
        y1="104.597"
        x2="40.666"
        y2="119.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57C41" />
        <stop offset="1" stop-color="#A67F46" />
      </linearGradient>
      <linearGradient
        id="paint16_linear"
        x1="37.124"
        y1="133.695"
        x2="37.124"
        y2="116.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C09C51" />
        <stop offset="1" stop-color="#C89C5D" />
      </linearGradient>
      <linearGradient
        id="paint17_linear"
        x1="41.088"
        y1="135.589"
        x2="40.357"
        y2="121.64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B58F49" />
        <stop offset="1" stop-color="#B78E4A" />
      </linearGradient>
      <linearGradient
        id="paint18_linear"
        x1="40.655"
        y1="104.521"
        x2="41.723"
        y2="119.799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57C41" />
        <stop offset="1" stop-color="#A67F46" />
      </linearGradient>
      <linearGradient
        id="paint19_linear"
        x1="64.505"
        y1="86.305"
        x2="54.02"
        y2="96.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A37D44" />
        <stop offset="1" stop-color="#A98247" />
      </linearGradient>
      <linearGradient
        id="paint20_linear"
        x1="69.745"
        y1="18.632"
        x2="70.928"
        y2="14.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A9D052" />
        <stop offset="1" stop-color="#AED258" />
      </linearGradient>
      <linearGradient
        id="paint21_linear"
        x1="86.093"
        y1="21.387"
        x2="88.976"
        y2="30.817"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8CBA42" />
        <stop offset="1" stop-color="#8CB84A" />
      </linearGradient>
      <linearGradient
        id="paint22_linear"
        x1="71.384"
        y1="38.106"
        x2="72.424"
        y2="42.615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7BB342" />
        <stop offset=".48" stop-color="#74AE43" />
        <stop offset="1" stop-color="#65A142" />
      </linearGradient>
      <linearGradient
        id="paint23_linear"
        x1="79.808"
        y1="41.731"
        x2="67.714"
        y2="48.713"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7CB042" />
        <stop offset="1" stop-color="#6DA843" />
      </linearGradient>
      <linearGradient
        id="paint24_linear"
        x1="47.611"
        y1="48.815"
        x2="53.121"
        y2="52.126"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#98C144" />
        <stop offset="1" stop-color="#95C442" />
      </linearGradient>
      <linearGradient
        id="paint25_linear"
        x1="38.793"
        y1="52.253"
        x2="47.138"
        y2="58.317"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9AC448" />
        <stop offset="1" stop-color="#9AC346" />
      </linearGradient>
      <linearGradient
        id="paint26_linear"
        x1="27.884"
        y1="43.07"
        x2="34.732"
        y2="37.524"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B1D355" />
        <stop offset="1" stop-color="#ACD151" />
      </linearGradient>
      <linearGradient
        id="paint27_linear"
        x1="10.848"
        y1="49.801"
        x2="15.489"
        y2="58.175"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0D357" />
        <stop offset="1" stop-color="#AED258" />
      </linearGradient>
      <linearGradient
        id="paint28_linear"
        x1="36.912"
        y1="54.256"
        x2="36.624"
        y2="58.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88B640" />
        <stop offset="1" stop-color="#7AAE42" />
      </linearGradient>
      <linearGradient
        id="paint29_linear"
        x1="24.245"
        y1="56.18"
        x2="25.511"
        y2="60.078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81B141" />
        <stop offset="1" stop-color="#7CAF42" />
      </linearGradient>
      <linearGradient
        id="paint30_linear"
        x1="52.726"
        y1="67.526"
        x2="59.739"
        y2="61.641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D457" />
        <stop offset="1" stop-color="#AED253" />
      </linearGradient>
      <linearGradient
        id="paint31_linear"
        x1="6.023"
        y1="54.124"
        x2="12.665"
        y2="60.767"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#90BD49" />
        <stop offset="1" stop-color="#8CBC42" />
      </linearGradient>
      <linearGradient
        id="paint32_linear"
        x1="2.179"
        y1="65.469"
        x2="10.451"
        y2="61.786"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B8D65B" />
        <stop offset="1" stop-color="#AED255" />
      </linearGradient>
      <linearGradient
        id="paint33_linear"
        x1="11.123"
        y1="62.858"
        x2="12.318"
        y2="60.788"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#71A642" />
        <stop offset="1" stop-color="#6DA341" />
      </linearGradient>
      <linearGradient
        id="paint34_linear"
        x1="7.368"
        y1="67.7"
        x2="17.888"
        y2="66.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#93C145" />
        <stop offset="1" stop-color="#77AF43" />
      </linearGradient>
      <linearGradient
        id="paint35_linear"
        x1="30.628"
        y1="74.625"
        x2="37.904"
        y2="80.731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#83B241" />
        <stop offset="1" stop-color="#81B141" />
      </linearGradient>
      <linearGradient
        id="paint36_linear"
        x1="89.104"
        y1="36.392"
        x2="91.363"
        y2="50.657"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9AC248" />
        <stop offset="1" stop-color="#9AC248" />
      </linearGradient>
      <linearGradient
        id="paint37_linear"
        x1="79.772"
        y1="58.331"
        x2="85.677"
        y2="50.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#84B141" />
        <stop offset="1" stop-color="#84B141" />
      </linearGradient>
      <linearGradient
        id="paint38_linear"
        x1="70.714"
        y1="64.904"
        x2="77.848"
        y2="62.022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#80B441" />
        <stop offset="1" stop-color="#8ABA40" />
      </linearGradient>
      <linearGradient
        id="paint39_linear"
        x1="78.758"
        y1="68.415"
        x2="92.82"
        y2="57.027"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#70A341" />
        <stop offset="1" stop-color="#7FAE41" />
      </linearGradient>
      <linearGradient
        id="paint40_linear"
        x1="65.037"
        y1="75.508"
        x2="61.661"
        y2="71.186"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7BAB41" />
        <stop offset="1" stop-color="#70A341" />
      </linearGradient>
      <linearGradient
        id="paint41_linear"
        x1="45.418"
        y1="80.626"
        x2="45.202"
        y2="74.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7FAE41" />
        <stop offset="1" stop-color="#75AA41" />
      </linearGradient>
      <linearGradient
        id="paint42_linear"
        x1="50.005"
        y1="74.463"
        x2="49.038"
        y2="76.859"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#90BE42" />
        <stop offset="1" stop-color="#8CBD3F" />
      </linearGradient>
      <linearGradient
        id="paint43_linear"
        x1="62.684"
        y1="84.457"
        x2="65.807"
        y2="77.099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#83B241" />
        <stop offset="1" stop-color="#7BAB41" />
      </linearGradient>
      <linearGradient
        id="paint44_linear"
        x1="54.693"
        y1="68.201"
        x2="55.864"
        y2="72.901"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#88B540" />
        <stop offset="1" stop-color="#83B241" />
      </linearGradient>
      <linearGradient
        id="paint45_linear"
        x1="75.54"
        y1="64.08"
        x2="76.743"
        y2="69.745"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#75AA41" />
        <stop offset="1" stop-color="#81B041" />
      </linearGradient>
      <linearGradient
        id="paint46_linear"
        x1="34.392"
        y1="62.609"
        x2="33.462"
        y2="58.878"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#75AA41" />
        <stop offset="1" stop-color="#6DA341" />
      </linearGradient>
      <linearGradient
        id="paint47_linear"
        x1="66.254"
        y1="47.966"
        x2="66.922"
        y2="43.745"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A7CD52" />
        <stop offset="1" stop-color="#9BCB48" />
      </linearGradient>
      <clipPath id="clip0">
        <path fill="#fff" transform="translate(0.239502 0.887207)" d="M0 0h147.3v118.5H0z" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    x: {
      type: [Number, String],
      default: 1475,
    },
    y: {
      type: [Number, String],
      default: 320,
    },
  },
};
</script>

<style lang="scss" scoped></style>
